import React, { useState } from "react";
import { AdminDokumenteTab } from "@/components/portal/AdminDokumenteTab";
import { AdminGalerienTab } from "@/components/portal/AdminGalerienTab";
import { AdminUmfragenTab } from "@/components/portal/AdminUmfragenTab";
import {
  Tabs, TabsList, TabsTrigger, TabsContent,
} from "@/components/ui/tabs";
import { FileText, Images, ListChecks } from "lucide-react";

export default function AdminDokumentePage() {
  const [tab, setTab] = useState("dokumente");
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-bold" style={{ fontFamily: "var(--font-heading)" }}>
          Portal-Inhalte
        </h1>
        <p className="text-sm text-muted-foreground">
          Dokumente, Bildergalerien und Umfragen für die Lieferanten – gezielt
          nach Milchsorte, Tour, Gruppe oder für alle Lieferanten freigeben.
        </p>
      </div>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="dokumente" data-testid="tab-dokumente">
            <FileText className="h-4 w-4 mr-2" /> Dokumente
          </TabsTrigger>
          <TabsTrigger value="galerien" data-testid="tab-galerien">
            <Images className="h-4 w-4 mr-2" /> Galerien
          </TabsTrigger>
          <TabsTrigger value="umfragen" data-testid="tab-umfragen">
            <ListChecks className="h-4 w-4 mr-2" /> Umfragen
          </TabsTrigger>
        </TabsList>
        <TabsContent value="dokumente" className="mt-4"><AdminDokumenteTab /></TabsContent>
        <TabsContent value="galerien" className="mt-4"><AdminGalerienTab /></TabsContent>
        <TabsContent value="umfragen" className="mt-4"><AdminUmfragenTab /></TabsContent>
      </Tabs>
    </div>
  );
}
